// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2G4Er","titleWrap":"style_titleWrap__3GFuL","actionsDropdownWrapper":"style_actionsDropdownWrapper__3WVpC"};